function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("desc", null, "Created with Fabric.js 5.2.4");

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(1 0 0 1 540 540)",
  id: "0554bb46-57d3-4bb7-88f6-f675066648ec"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: 1.1,
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "bfc6cac4-2061-4935-bf92-105999e7a327"
  }, React.createElement("rect", {
    style: {
      "stroke": "none",
      "strokeWidth": 1,
      "strokeDasharray": "none",
      "strokeLinecap": "butt",
      "strokeDashoffset": 0,
      "strokeLinejoin": "miter",
      "strokeMiterlimit": 4,
      "fill": "rgb(255,255,255)",
      "fillRule": "nonzero",
      "opacity": 1,
      "visibility": "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)"
  }, React.createElement("path", {
    style: {
      "stroke": "rgb(0,0,0)",
      "strokeWidth": 0,
      "strokeDasharray": "none",
      "strokeLinecap": "butt",
      "strokeDashoffset": 0,
      "strokeLinejoin": "miter",
      "strokeMiterlimit": 4,
      "fill": "rgb(221,221,221)",
      "fillRule": "nonzero",
      "opacity": 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-501, 480)",
    d: "M 576 -432 L 648 -360 Q 658 -350 672 -350 Q 686 -350 696 -360 Q 706 -370 706 -384 Q 706 -398 696 -408 L 624 -480 L 696 -552 Q 706 -562 706 -576 Q 706 -590 696 -600 Q 686 -610 672 -610 Q 658 -610 648 -600 L 576 -528 L 504 -600 Q 494 -610 480 -610 Q 466 -610 456 -600 Q 446 -590 446 -576 Q 446 -562 456 -552 L 528 -480 L 456 -408 Q 446 -398 446 -384 Q 446 -370 456 -360 Q 466 -350 480 -350 Q 494 -350 504 -360 L 576 -432 Z M 372 -192 Q 355 -192 340 -199.5 Q 325 -207 314 -221 L 152 -437 Q 138 -457 138 -480 Q 138 -503 152 -523 L 314 -739 Q 325 -753 340 -760.5 Q 355 -768 372 -768 L 792 -768 Q 822 -768 843 -747 Q 864 -726 864 -696 L 864 -264 Q 864 -234 843 -213 Q 822 -192 792 -192 L 372 -192 Z",
    strokeLinecap: "round"
  })), React.createElement("g", {
    transform: "matrix(4.19 0 0 4.19 614.31 540)"
  }, React.createElement("path", {
    style: {
      "stroke": "rgb(0,0,0)",
      "strokeWidth": 0,
      "strokeDasharray": "none",
      "strokeLinecap": "butt",
      "strokeDashoffset": 0,
      "strokeLinejoin": "miter",
      "strokeMiterlimit": 4,
      "fill": "rgb(0,0,0)",
      "fillRule": "nonzero",
      "opacity": 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-50, -50)",
    d: "M 16.28 19.945 L 19.957 16.32 C 22.060000000000002 14.166 25.578000000000003 14.166 27.681 16.32 L 50.007000000000005 38.595 L 72.333 16.32 C 74.43599999999999 14.166 77.954 14.166 80.054 16.32 L 83.68 19.945 C 85.834 22.046 85.834 25.566000000000003 83.68 27.668 L 61.405 49.993 L 83.68 72.32 C 85.834 74.422 85.834 77.939 83.68 80.04299999999999 L 80.054 83.72099999999999 C 77.95400000000001 85.82 74.436 85.82 72.333 83.72099999999999 L 50.007 61.393 L 27.681 83.721 C 25.578 85.82000000000001 22.060000000000002 85.82000000000001 19.957 83.721 L 16.28 80.043 C 14.180000000000001 77.93900000000001 14.180000000000001 74.42200000000001 16.28 72.32000000000001 L 38.606 49.99300000000001 L 16.28 27.667 C 14.18 25.566 14.18 22.046 16.28 19.945 z",
    strokeLinecap: "round"
  })));
};

export default __webpack_public_path__ + "static/media/close-mark.db689118.svg";
export { SvgComponent as ReactComponent };